import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer';
import './activation.css';
import Beard from '../../assets/images/logo-beard2.svg';
import Img2 from '../../assets/images/img2.png';
import Card from '../../assets/icons/card.svg';
import Refresh from '../../assets/icons/refresh.svg';
import { Form, Modal } from 'react-bootstrap';
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';
import { fastCharge, getCharge } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader'
import { Dialog } from 'primereact/dialog';
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import useStickToTopModal from '../../hooks/useStickToTopModal';
import useToastNotification from '../../hooks/useToastNotification';
import Info from '../../assets/icons/info.svg';

function Activation() {
    const toast = useRef(null);
    const [setting, setSetting] = useState('');
    const [changePassLoader, setChangePassLoader] = useState(false)
    const [part1, setPart1] = useState('6221');
    const [part2, setPart2] = useState('');
    const [part3, setPart3] = useState('');
    const [part4, setPart4] = useState('');
    const [amount, setAmount] = useState('');
    const [validated, setValidated] = useState(false);
    const [otpVisible, setOtpVisible] = useState(false);
    const [otp, setOtp] = useState('')
    const [time, setTime] = useState(240); // Initialize with 3 minutes (180 seconds)
    const [resendBtn, setResendBtn] = useState(true);
    const [typePassword, setTypePassword] = useState('password');
    const [isActive, setIsActive] = useState(false);
    const [password, setPassword] = useState('')

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobile, setMobile] = useState('');
    const [nationalId, setNationalId] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaValid, setCaptchaValid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const [success, setSuccess] = useState('');
    const [captchaText, setCaptchaText] = useState('');

    const { showError, showSuccess } = useToastNotification();

    const part2Ref = useRef(null);
    const part3Ref = useRef(null);
    const part4Ref = useRef(null);
    const amoutRef = useRef(null);

    useEffect(() => {

        setTimeout(() => {

            const set = localStorage.getItem('settings');

            setSetting(JSON.parse(set));
            loadCaptchaEnginge(6, 'white', 'black', 'numbers'); // تولید 6 کاراکتر کپچا


        }, 1000);
        if (localStorage.getItem('userData')) {
            const token = JSON.parse(localStorage.getItem('userData'));
            setToken(token.token)
        }
    }, []);
    useEffect(() => {

    }, [setting])
    const handleCaptchaValidation = () => {
        if (validateCaptcha(captchaInput.toLowerCase())) {
            setCaptchaValid(true);
            // alert('CAPTCHA validated successfully!');
        } else {
            setCaptchaValid(false);
            let message = {
                text: 'لطفا کد امنیتی را صحیح وارد کنید.'
            }
            showError(message)
            return
        }
    };

    const handlePart1Change = (e) => {
        setPart1(e.target.value);
        if (e.target.value.length === 4) part2Ref.current.focus();
    };

    const handlePart2Change = (e) => {
        setPart2(e.target.value);
        if (e.target.value.length === 4) part3Ref.current.focus();
    };

    const handlePart3Change = (e) => {
        setPart3(e.target.value);
        if (e.target.value.length === 4) part4Ref.current.focus();
    };

    const handlePart4Change = (e) => {
        setPart4(e.target.value);
        if (e.target.value.length === 4) amoutRef.current.focus();
    };

    const submitCharge = async (e) => {

        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            if (!validateCaptcha(captchaInput.toLowerCase())) {
                // setCaptchaValid(true);
                setCaptchaValid(false);
                let message = {
                    text: 'لطفا کد امنیتی را صحیح وارد کنید.'
                }
                loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                setCaptchaInput('')
                showError(message)
            } else if (parseInt(amount) < setting?.chargeMin || parseInt(amount) > setting?.chargeMax) {
                let message = {
                    text: `لطفا محدوده قیمتی خود را بین ${parseInt(setting?.chargeMin).toLocaleString()} و ${parseInt(setting?.chargeMax).toLocaleString()} وارد کنید.`
                }
                showSuccess(message)
               
                // loadCaptchaEnginge(6, 'white', 'black', 'numbers')

            } else if (mobile.length == 11 && mobile.startsWith("09")) {
                showChargeModal()
            } else {
                let message = {
                    text: `لطفا شماره موبایل را صحیح وارد کنید.`
                }
                showError(message)

            }

        }
        setValidated(true);

    };

    const getCardNumber = ()=>{
        return `${part1}-${part2}-${part3}-${part4}`
    }
    const submitFastCharge = async () => {

        setCaptchaValid(true);

        const cardNumber = `${part1}${part2}${part3}${part4}`;
        const requestData = {
            amount: parseInt(amount),
            firstName,
            lastName,
            mobile,
            nationalCode: nationalId,
            cardNumber,
        };
        setLoading(true);


        try {
            setModalChargeShow(false)
            const response = await fastCharge(requestData);
            if (response.data.isSuccess) {
                // setLoading(false);
                setOtpVisible(true)
                setTime(240)
                setIsActive(true);
                setResendBtn(true);

            } else {
                loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                setCaptchaInput('')
                let message = {
                    text: response.data.message
                }
                showError(message)
                setLoading(false);
                setModalChargeShow(false)
            }
        } catch (error) {
            loadCaptchaEnginge(6, 'white', 'black', 'numbers')
            setCaptchaInput('')
            setLoading(false);
            let message = {
                text: error.response ? error.response?.data.error : 'خطا در برقراری ارتباط با سرور'
            }
            loadCaptchaEnginge(6, 'white', 'black', 'numbers')
            setCaptchaInput('')
            // setOtpVisible(true)
            // setTime(120)
            // setIsActive(true);
            // setResendBtn(true);
            showError(message)
        } finally {
            // setLoading(false);
        }
    }
    const finalCharge = async (e) => {
        e.preventDefault();
        const cardNumber = `${part1}${part2}${part3}${part4}`;
        const requestData = {
            amount: parseInt(amount),
            firstName,
            lastName,
            mobile,
            otp: otp,
            nationalCode: nationalId,
            cardNumber,
        };
        setChangePassLoader(true);


        try {
            const response = await fastCharge(requestData);
            if (response.data.isSuccess) {
                // setChangePassLoader(true);
                // localStorage.setItem('ChargeOrderId', response.data.data.orderId)
                window.location.replace(response.data.data.urlRedirect);
            } else {
                setChangePassLoader(false);
                setOtpVisible(false)
                let message = {
                    text: response.data.message
                }
                loadCaptchaEnginge(6, 'white', 'black', 'numbers')
                setCaptchaInput('')
                showError(message)
            }
        } catch (error) {
            setChangePassLoader(false);
            let message = {
                text: error.response ? error.response?.data.error : 'خطا در برقراری ارتباط با سرور'
            }
            showError(message)
        } finally {
            // setChangePassLoader(false);
        }


    };
    const formatAmount = (value) => {
        if (!value) return '';
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as thousand separators
    };

    const handleAmountChange = (input) => {
        const rawValue = input.replace(/,/g, ''); // Remove existing commas
        if (/^\d*$/.test(rawValue)) { // Ensure the value is numeric
            setAmount(rawValue);
        }
    };
    const showPassword = () => {
        setTypePassword('text')
    }
    const hidePassword = () => {
        setTypePassword('password')
    }
    const updateCardNumberViaPaste = (card) => {
        setPart2(card.slice(4, 8));
        setPart3(card.slice(8, 12));
        setPart4(card.slice(12, 16));
    };

    const onCardPaste = (e) => {
        e.preventDefault();
        let value = (e.clipboardData.getData('text'));
        if (!value || value.length !== 16) {
            return;
        }
        try {
            for (let index = 2; index <= 4; index++) {
                let input = document.getElementById(`web-card-${index}`);
                // input.value = value.slice((index - 1) * 4, index * 4);
                input.innerText = value.slice((index - 1) * 4, index * 4);
            }
            updateCardNumberViaPaste(value);
        } catch (error) {
            console.log(error);
        }
    };
    //setTimer
    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish(); // Call the function when the timer reaches 0
        }
        // Cleanup interval on component unmount or when time reaches 0
        return () => clearInterval(timerId);
    }, [isActive, time]);

    //finishTimer
    const onTimerFinish = () => {
        setResendBtn(false);
    }

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }
    const cardCharging = async (e) => {
        e.preventDefault()

        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            if (!validateCaptcha(captchaInput.toLowerCase())) {
                // setCaptchaValid(true);
                setCaptchaValid(false);
                let message = {
                    text: 'لطفا کد امنیتی را صحیح وارد کنید.'
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
            } else if (parseInt(amount) < setting?.chargeMin || parseInt(amount) > setting?.chargeMax) {
                let message = {
                    text: `لطفا محدوده قیمتی خود را بین ${parseInt(setting?.chargeMin).toLocaleString()} و ${parseInt(setting?.chargeMax).toLocaleString()} وارد کنید.`
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
            } else {
                showLogoModal()
            }
        }
        setValidated(true);

    }


    const gotoCharge = async () => {
        try {
            setLoading(true)

            let pay = {
                amount: amount ? parseInt(amount) : 0,
                cardNumber: `${part1}${part2}${part3}${part4}`,
            }
            let res = await getCharge(pay)
            if (res.data.isSuccess) {
                // setLoading(false)
                // localStorage.setItem('ChargeOrderId', res.data.data.orderId)
                window.location.replace(res.data.data.urlRedirect);
            } else {
                let message = {
                    text: res.data.message
                }
                showError(message)
                loadCaptchaEnginge(6, 'white', 'black', 'numbers');
                setCaptchaInput('')
                setLoading(false)
                setModalLogoShow(false)

            }


        } catch (error) {
            setLoading(false)
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }
    }

    const { modalClassName, onKeyboardClose, onKeyboardOpen, stickToTop } = useStickToTopModal();
    // useEffect(() => {
    //     if (otpVisible === true) {
    //         return onKeyboardOpen();
    //     }
    //     onKeyboardClose();
    // }, [otpVisible])
    function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }

    const [ModalchargeShow, setModalChargeShow] = React.useState(false);
    const [ModalLogoShow, setModalLogoShow] = React.useState(false);
    const closeLogoModal = () => {
        setModalLogoShow(false);
    };
    const showLogoModal = () => {
        setModalLogoShow(true);
    };


    const closeChargeModal = () => {
        setModalLogoShow(false);
    };
    const showChargeModal = () => {
        setModalChargeShow(true);
    };
    return (
        <div>
            <Toast ref={toast} />

            <div className="container">
                <div className="d-flex align-items-center title gap-3">
                    <img src={Beard} alt="Logo" />
                    شارژ سریع کارت هدیه کادونا
                </div>
                {token && token != '' ? (<div className="d-flex align-items-center justify-content-between gap-5 mt-3 w-100 flex-col-revers mb-5">
                    <div className="charging-card mb-5">
                        <div className="color-gray number">
                            تعداد شارژ مجاز باقی مانده برای امروز: {setting?.dailyChargeLimit}
                        </div>
                        <hr />
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <Form noValidate validated={validated} onSubmit={(e) => cardCharging(e)}>
                            <Form.Group controlId="text">
                                <Form.Label>شماره کارت <span className='text-[red]'> * </span></Form.Label>
                                <div className="input-icon" style={{ direction: 'ltr' }}>
                                    <img src={Card} alt="Card Icon" />
                                    <Form.Control
                                        type="number"
                                        readOnly
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part1}
                                        onChange={handlePart1Change}
                                        maxLength="4"
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part2}
                                        onChange={handlePart2Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        id="web-card-2"

                                        ref={part2Ref}
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part3}
                                        onChange={handlePart3Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        ref={part3Ref}
                                        id="web-card-3"
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part4}
                                        onChange={handlePart4Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        ref={part4Ref}
                                        id="web-card-4"
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>مبلغ شارژ <span className='text-[red]'> * </span> <span style={{ fontSize: '12px' }}>(مبلغ شارژ را به تومان وارد کنید)</span></Form.Label>
                                <Form.Control
                                    className='number'
                                    required
                                    placeholder={`بین ${parseInt(setting?.chargeMin).toLocaleString()} تومان تا ${parseInt(setting?.chargeMax).toLocaleString()} تومان`}
                                    ref={amoutRef}
                                    type="text" // Change type to text for custom formatting
                                    value={formatAmount(amount)} // Apply formatting to the displayed value
                                    onChange={(e) => handleAmountChange(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا مبلغ را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>کد امنیتی <span className='text-[red]'> * </span></Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        value={captchaInput}
                                        onChange={(e) => setCaptchaInput(e.target.value)}
                                        placeholder="کد امنیتی را وارد کنید"
                                    />
                                    <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">
                                        <LoadCanvasTemplate />
                                        <button
                                            type="button"
                                            onClick={() => { loadCaptchaEnginge(6, 'white', 'black', 'numbers'); setCaptchaInput('') }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                color: '#007BFF',
                                                marginLeft: '10px',
                                                width: '18px'
                                            }}
                                            title="تولید مجدد کد امنیتی"
                                        >
                                            <img src={Refresh} alt="" />
                                        </button>
                                    </div>
                                </div>
                            </Form.Group>
                            <button
                                className="btn btn-primary w-100 mt-1 text-center mt-3"
                                type="submit"

                                disabled={loading}
                                style={{ width: 'auto' }}
                            >شارژ کنید

                            </button>
                            <div className=' d-flex gap-2 mt-3 align-items-start'>
                                <img src={Info} alt="" />
                                <div>
                                    <h6 className='text-[#0033CC] text-sm'>
                                        {
                                            convertToPersianNumbers('کارت شارژ شده، پس از 48 ساعت فعال خواهد شد.')
                                        }

                                    </h6>
                                </div>
                            </div>
                        </Form>
                    </div>

                    <div className="flex-1" style={{ textAlign: '-webkit-left' }}>
                        <img src={Img2} alt="Illustration" />
                    </div>
                </div>) : (<div className="d-flex align-items-center justify-content-between gap-5 mt-3 w-100 flex-col-revers mb-5">
                    <div className="charging-card mb-5">
                        <div className="color-gray number">
                            تعداد شارژ مجاز باقی مانده برای امروز: {setting?.dailyChargeLimit}
                        </div>
                        <hr />
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <Form noValidate validated={validated} onSubmit={(e) => submitCharge(e)}>
                            <Form.Group controlId="text">
                                <Form.Label>شماره کارت <span className='text-[red]'> * </span></Form.Label>
                                <div className="input-icon" style={{ direction: 'ltr' }}>
                                    <img src={Card} alt="Card Icon" />
                                    <Form.Control
                                        type="number"
                                        readOnly
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part1}
                                        onChange={handlePart1Change}
                                        maxLength="4"
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part2}
                                        onChange={handlePart2Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        ref={part2Ref}
                                        id="web-card-2"
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part3}
                                        onChange={handlePart3Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        ref={part3Ref}
                                        id="web-card-3"
                                    />{' '}
                                    -
                                    <Form.Control
                                        type="number"
                                        inputMode="numeric"
                                        className="text-center number"
                                        value={part4}
                                        onChange={handlePart4Change}
                                        maxLength="4"
                                        onPaste={onCardPaste}
                                        ref={part4Ref}
                                        id="web-card-4"
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>مبلغ شارژ <span className='text-[red]'> * </span><span style={{ fontSize: '12px' }}>(مبلغ شارژ را به تومان وارد کنید)</span></Form.Label>
                                <Form.Control
                                    className='number'
                                    required
                                    placeholder={`بین ${parseInt(setting?.chargeMin).toLocaleString()} تومان تا ${parseInt(setting?.chargeMax).toLocaleString()} تومان`}

                                    ref={amoutRef}
                                    type="text" // Change type to text for custom formatting
                                    value={formatAmount(amount)} // Apply formatting to the displayed value
                                    onChange={(e) => handleAmountChange(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا مبلغ را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>نام <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />     <Form.Control.Feedback type="invalid">
                                    لطفا نام را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا نام خانوادگی را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>شماره موبایل <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    inputMode="numeric"
                                    value={mobile}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 11) {
                                            setMobile(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                                        }
                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا شماره را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>کدملی <span className='text-[red]'> * </span></Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    inputMode="numeric"
                                    value={nationalId}
                                    onChange={(e) => setNationalId(e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    لطفا کدملی را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mt-3">
                                <Form.Label>کد امنیتی <span className='text-[red]'> * </span></Form.Label>
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        value={captchaInput}
                                        onChange={(e) => setCaptchaInput(e.target.value)}
                                        placeholder="کد امنیتی را وارد کنید"
                                    />
                                    <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">
                                        <LoadCanvasTemplate />
                                        <button
                                            type="button"
                                            onClick={() => { loadCaptchaEnginge(6, 'white', 'black', 'numbers'); setCaptchaInput('') }}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                                color: '#007BFF',
                                                marginLeft: '10px',
                                                width: '18px'
                                            }}
                                            title="تولید مجدد کد امنیتی"
                                        >
                                            <img src={Refresh} alt="" />
                                        </button>
                                    </div>
                                </div>
                            </Form.Group>
                            <button
                                className="btn btn-primary w-100 mt-1 text-center mt-3"
                                type="submit"

                                disabled={loading}
                                style={{ width: 'auto' }}
                            >ارسال کد فعالسازی

                            </button>
                            <div className=' d-flex gap-2 mt-3 align-items-start'>
                                <img src={Info} alt="" />
                                <div>
                                    <h6 className='text-[#0033CC] text-sm'>  {
                                        convertToPersianNumbers('کارت شارژ شده، پس از 48 ساعت فعال خواهد شد.')
                                    }</h6>
                                </div>
                            </div>
                        </Form>
                    </div>

                    <div className="flex-1" style={{ textAlign: '-webkit-left' }}>
                        <img src={Img2} alt="Illustration" />
                    </div>
                </div>)}

            </div>
            <Dialog className={`animation ${stickToTop ? modalClassName : ''}`} header="رمز عبور" visible={otpVisible} style={{ width: '40vw' }} onHide={() => { if (!otpVisible) return; { setOtpVisible(false); setLoading(false); loadCaptchaEnginge(6, 'white', 'black', 'numbers') } }}>
                <div className='login-card w-100'>
                    <div className='item mx-0' >
                        <h6 className='text-xl font-medium	color-primary2 mt-5'> کد تایید ارسالی  برای شماره {mobile} را وارد کنید.</h6>
                        <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => finalCharge(e)}>
                            <Form.Group controlId="postalCode" >
                                <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                                <Form.Control className='number' type="number" autocomplete="one-time-code" inputMode="numeric" required value={otp} onChange={(e) => {
                                    if (e.target.value.length <= 6) {
                                        setOtp(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                                    }
                                }} onKeyDown={(e) => {

                                    if (e.key === 'Enter') {
                                        e.preventDefault(); // Prevent form submission
                                        finalCharge(e); // Call login function
                                    }
                                }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />

                            </Form.Group>

                            <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2 number' onClick={submitCharge}> {resendBtn ? formatTime(time) : 'ارسال مجدد'}</button>
                            <button className='btn btn-primary w-100 mt-2 text-center' disabled={changePassLoader} type='submit' style={{ width: 'auto' }}>ادامه {changePassLoader && <Loader />}</button>


                        </Form>
                    </div>
                </div>
            </Dialog>
            <div className="home-footer mt-40">
                <Footer />
            </div>



            <Modal
                show={ModalLogoShow}
                onHide={() => setModalLogoShow(false)}
                centered
            >
                <Modal.Body className='!p-5'>
                    <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
                        <img src={require('../../assets/icons/danger.svg').default} alt="" />
                        <div className="font-bold text-blue">هشدار</div>
                    </div>
                    <div className='font-bold mt-4'>آیا از انجام عملیات شارژ به مبلغ {parseInt(amount).toLocaleString()} برای کارت هدیه با شماره {getCardNumber()} اطمینان دارید؟</div>
                    <div className="flex gap-2 mt-4">
                        <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={() => setModalLogoShow(false)}>انصراف</button>
                        <button className='btn btn-primary flex-[2]' onClick={() => gotoCharge()}>تایید    {loading ? <Loader /> : ''}</button>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal
                show={ModalchargeShow}
                onHide={() => setModalChargeShow(false)}
                centered
            >
                <Modal.Body className='!p-5'>
                    <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
                        <img src={require('../../assets/icons/danger.svg').default} alt="" />
                        <div className="font-bold text-blue">هشدار</div>
                    </div>
                    <div className='font-bold mt-4'>آیا از انجام عملیات شارژ به مبلغ {parseInt(amount).toLocaleString()} برای کارت هدیه با شماره {getCardNumber()} اطمینان دارید؟</div>
                    <div className="flex gap-2 mt-4">
                        <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={() => setModalChargeShow()}>انصراف</button>
                        <button className='btn btn-primary flex-[2]' onClick={() => submitFastCharge()}>تایید    {loading ? <Loader /> : ''}</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Activation;
